module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Little-Drummer-Girl.b9e5686.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Little-Drummer-Girl.jpg
// module id = kkcT
// module chunks = 0